import React from "react";
import { Button } from "antd";
import styles from "./index.module.scss";
import useModalHandler from "../../../../../utils/v2/useModalHandler";
import AllModal from "../../all/components/AllModal";

interface ButtonDetailProps {
    examId: string;
    stuNo: string;
    ban: string;
    onChange(): void;
}

export default function ButtonDetail({ onChange }: ButtonDetailProps) {
    const allModal = useModalHandler(undefined, { remove: true });

    function onOpen() {
        allModal.open();
    }

    return (
        <>
            <Button className={styles.button} type="link" onClick={onOpen}>
                查看详情
            </Button>
            {allModal.render(<AllModal refresh={onChange} />)}
        </>
    );
}
